import React, { memo, useContext } from 'react'

import { Icon, RotatingSpinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { closeDetachedHistory } from 'Pods/ThreeDStudio/Store/actions/ui'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import CategoryFilters from './Components/CategoryFilters/CategoryFilters'
import DetachedWindow from './Components/DetachedWindow/DetachedWindow'
import EmptyState from './Components/EmptyState/EmptyState'
import Grid from './Components/Grid/Grid'
import Header from './Components/Header/Header'
import useCategoryFilters from './Hooks/useCategoryFilters'
import useVariationsTab from './Hooks/useVariationsTab'

const spinnerSize = { height: '32px', width: '32px' }

function VariationsTab({ isDetached = false }) {
  const t = useTranslation()
  const { historyTabEnabled } = useContext(ThreeDStudioPageContext)
  const {
    variations,
    uploadedAsset,
    isLoading,
    isEnhanced,
    assignMain,
    deleteVariation,
    ...gridProps
  } = useVariationsTab()
  const {
    selectedCategory,
    countByCategory,
    filteredVariations,
    selectCategory,
  } = useCategoryFilters(variations)

  const shouldShowUploadedAsset = !historyTabEnabled || selectedCategory == null
  const title = t(`viewerSidebar.enhance.variations.${historyTabEnabled ? 'historyTitle' : 'title'}`)

  const content = (
    <>
      {historyTabEnabled && (
        <CategoryFilters
          allCount={variations.length + (uploadedAsset ? 1 : 0)}
          countByCategory={countByCategory}
          selectedCategory={selectedCategory}
          onSelect={selectCategory}
        />
      )}
      {isLoading && (
        <div className="variations-tab__loading">
          <Icon svgComponent={RotatingSpinner} color="primary" size={spinnerSize} notSpaced />
        </div>
      )}
      {!isLoading && variations.length > 0 && (
        <Grid
          {...gridProps}
          variations={historyTabEnabled ? filteredVariations : variations}
          uploadedAsset={shouldShowUploadedAsset ? uploadedAsset : null}
          canOpenRelatedTab={historyTabEnabled && !isDetached}
          isWide={isDetached}
          showInfo={historyTabEnabled}
          onSetAsMain={assignMain}
          onDelete={deleteVariation}
        />
      )}
      {!isLoading && !isEnhanced && <EmptyState />}
    </>
  )

  if (isDetached) {
    return (
      <DetachedWindow title={title} onClose={closeDetachedHistory}>
        {content}
      </DetachedWindow>
    )
  }

  return (
    <div className="enhance-model-panel__tab">
      <Header title={title} canDetach={historyTabEnabled} />
      {content}
    </div>
  )
}

VariationsTab.propTypes = {
  isDetached: bool,
}

export default memo(VariationsTab)
